//Generator Url: http://localhost:8033/api/ocr/getapi
import request from '~/utils/request';
//import './OCRApi.d';
export namespace OCRApi {
    export const scan = (param: IOCRScanParam, loadingOptions?: IRequestLoadingOption) => request<IOCRResult>({
        method: 'post',
        url: 'OCR/Scan',
        data: param,
        loadingOptions
    })

    // ------------ model define ------------- //


    export const enum OCRRecommendder {
        None = 0,
        Order = 1,
        Rule = 2,
        OpenSDK = 4,
        AiVision = 8
    }


    export interface IOCRResultItem {

        Text?: NString

        Recommendder: OCRRecommendder
    }


    export interface IOCRResultPartNoItem extends IOCRResultItem {

        Package: Array<NString>
    }


    export interface IOCRResult {

        PartNo: Array<IOCRResultPartNoItem>

        Qty: Array<IOCRResultItem>

        Brand: Array<IOCRResultItem>

        DateCode: Array<IOCRResultItem>

        RegionName: Array<IOCRResultItem>

        All: Array<NString>
    }


    export interface IOCRScanParam {
        /**上传后的文件内容
        *System.Guid*/
        FileID: string
        /**订单ID
        *System.Int32*/
        OrderId: number
        /**经Base64编码的图片对象
        *System.String*/
        ImageData?: NString
    }

}
export default OCRApi